<main class="main">
  <section class="wrap-title"
    style="background: url('https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/auto-vistoria_1920x324.png'); background-size: cover;">
    <div class="layout">
      <h1 class="title-page">Vistoria Autônoma</h1>
    </div>
  </section>

  <section class="wrap-content">
    <div class="layout">
      <div class="content">
        <div class="left">
          <div class="ckeditor">
            <p>Para quem busca um processo de vistoria feito de forma prática e rápida, a Auto Vistoria é a solução
              ideal. Através de processos automatizados de aceitação documental, inspeção e vistoria realizados pelo
              próprio cliente e garantidos pela Union, a sua empresa assume o total controle na AUTO INSPEÇÃO dos
              veículos.</p>
            <p>Um sistema moderno e totalmente intuitivo, onde o usuário realiza a vistoria via token e dispensa a
              necessidade de processos físicos e e-mails. Tudo pensado para o melhor custo-benefício para a sua empresa.
            </p>
          </div>
          <figure class="fig_mobile">
            <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/MicrosoftTeams-image-1.jpg" alt="Microsoft Teams Mobile" loading="lazy">
          </figure>
          <div class="button">
            <a class="btn gradient" href="https://unionsolutions.com.br/vistoria-autonoma">Exemplo de consulta</a>
          </div>
        </div>
        <div class="right">
          <figure class="fig">
            <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/MicrosoftTeams-image-1.jpg" alt="Microsoft Teams" loading="lazy">
          </figure>
        </div>
      </div>

    </div>
  </section>

  <section class="wrap-vcl">
    <div class="layout">
      <div class="box">
        <div class="content" style="width: 100%">
          <div class="list-topics">
            <div class="topic">
              <div class="icon">
                <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/dash.png">
              </div>
              <div class="text">
                <p>Dashboard intuitivo e personalizável;</p>
              </div>
            </div>
            <div class="topic">
              <div class="icon">
                <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/Grupo-1064.png">
              </div>
              <div class="text">
                <p>Acesso a todos os serviços iniciados, pendentes e finalizados;</p>
              </div>
            </div>
            <div class="topic">
              <div class="icon">
                <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/a-r.png">
              </div>
              <div class="text">
                <p>Aceitação e reprovação direto pela plataforma;</p>
              </div>
            </div>
            <div class="topic">
              <div class="icon">
                <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/real-time.png">
              </div>
              <div class="text">
                <p>Informações em tempo real;</p>
              </div>
            </div>
            <div class="topic">
              <div class="icon">
                <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/notificacao.png">
              </div>
              <div class="text">
                <p>Personalização de notificações para o cliente;</p>
              </div>
            </div>
            <div class="topic">
              <div class="icon">
                <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/analise-de-mercado.png">
              </div>
              <div class="text">
                <p>Análise inteligente de possíveis inseguranças;</p>
              </div>
            </div>
            <div class="topic">
              <div class="icon">
                <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/localizacao.png">
              </div>
              <div class="text">
                <p>Imagens com geolocalização de alta precisão;</p>
              </div>
            </div>
            <div class="topic">
              <div class="icon">
                <img src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/select.png">
              </div>
              <div class="text">
                <p>Totalmente personalizável para a sua empresa.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <app-contact-box></app-contact-box>

</main>
